import Vue from 'vue';
import routes from "./router";
import VueRouter from "vue-router";
import VueAlertify from "vue-alertify";
import App from "./frontend/App";
import store from "./frontend/Vuex";
import vSelect from 'vue-select';
import helper from "./helper";
import 'vue-select/dist/vue-select.css';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask';

Vue.component('v-select', vSelect);
Vue.use(VueRouter)
    .use(VueSweetalert2)
    .use(VueMask)
    .use(VueAlertify);

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(function (config) {
    //  Generate cancel token source
    let source = axios.CancelToken.source();
    
    if(config.url === '/api/profile') return config;
    
    config.cancelToken = source.token;

    store.commit('cancelToken/ADD_CANCEL_TOKEN', source);
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(
    response => response,
    async error => {
        if (error?.response?.status === 422) {
            if (error.response.data.errors?.userBanned) {
                await store.dispatch('cancelToken/CANCEL_PENDING_REQUESTS');
                const VUE = {prototype: {}}
                VueAlertify.install(VUE, {})
                VUE.prototype.$alertify.error(Object.values(error.response.data.errors)?.[0]?.[0] ?? "Something went wrong");
                setTimeout(() => window.location.href = '/', 2000);
                if(localStorage.get('logged')) localStorage.removeItem('logged')
                return;
            }
        }
        return Promise.reject(error);
    }
);

Vue.filter('toCurrency', function (amount) {
    if (amount === null) {
        return '0';
    }
    return Number(amount).toLocaleString();
});

String.prototype.ltrim = function (character) {
    const first = [...this.toString()].findIndex(char => char !== character);
    return this.substring(first, this.length);
};

const router = new VueRouter(routes);

router.beforeResolve((to, from, next) => {
    if (to.name) {
        store.commit('SET_LOADING');
    }
    next();
});

router.beforeEach(async (to, from, next) => {
    await store.dispatch('cancelToken/CANCEL_PENDING_REQUESTS');
    next();
});

router.afterEach((to, from) => {
    setTimeout(() => {
        // ga('send', 'pageview');
        store.commit('UNSET_LOADING');
    }, 200);

});

Vue.prototype.$helper = helper;

Vue.directive('click-away', {
    bind(el, binding, vnode) {
        window.events = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value.bind(vnode.context)(event);
            }
        };
        document.body.addEventListener('click', window.events);
    },
    unbind() {
        document.body.removeEventListener('click', window.events);
    },
});

import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

Vue.component('frontend-header',() => import(/*webpackChunkName:"js/frontend-header"*/ './frontend/components/Header.vue'));
Vue.component('frontend-footer',() => import(/*webpackChunkName:"js/frontend-footer"*/ './frontend/components/Footer.vue'));

new Vue({
    store,
    router,
    components: {
        App
    },
    el: '#front-app'
});
